import type { RoadSectionId } from '../../domain/Reference';
import { roadSectionsQuery } from '../../reference/queries';
import { createCommand } from '../../utils';
import { perimeterQuery, selectedIdsQuery } from '../queries';
import { rangeOnAxis, SelectionModifier, toggleId } from '../selection';
import { SelectRoadSectionsCommand } from './SelectRoadSectionsCommand';

// A click on a section of the map. Plain: select only it. Ctrl/Cmd: add or remove it. Shift: select the
// range along the axis from the anchor (or just add it when it is on another axis, or there is no anchor).
// Sections the filters leave out can neither be clicked nor fall in a range.
export const ClickRoadSectionCommand = createCommand<{ id: RoadSectionId; modifier: SelectionModifier }>(
    'MAP_V2/CLICK_ROAD_SECTION',
    async ({ id, modifier }, { dispatch, getState }) => {
        const state = getState();
        const perimeter = perimeterQuery(state);
        if (!perimeter.includes(id)) {
            // Dimmed by the filters: not part of what the map shows.
            return;
        }
        const selected = selectedIdsQuery(state);
        if (modifier === 'toggle') {
            await dispatch(SelectRoadSectionsCommand({ ids: toggleId(selected, id), anchor: id }));
        } else if (modifier === 'range') {
            const anchor = state.mapV2.selectionAnchor ?? selected[0] ?? null;
            const range = rangeOnAxis(roadSectionsQuery(state), anchor, id)?.filter(perimeter.includes) ?? null;
            const ids = range ?? (selected.includes(id) ? selected : [...selected, id]);
            await dispatch(SelectRoadSectionsCommand({ ids, anchor: id }));
        } else {
            await dispatch(SelectRoadSectionsCommand({ ids: [id], anchor: id }));
        }
    },
);
